export default {
  setIsInitialized(state, payload) {
    state.isInitialized = payload;
  },
  setIsAppLoading(state, payload) {
    if (payload)
      document.getElementsByTagName('body')[0].classList.add('is-loading');
    else
      document.getElementsByTagName('body')[0].classList.remove('is-loading');

    state.isAppLoading = payload;
  },
  setGoogleVerifyKey(state, payload) {
    state.googleVerifyKey = payload;
  },
  setMaintenanceModeActive(state, payload) {
    state.maintenanceModeActive = payload;
  },
  setMaintenanceModeContent(state, payload) {
    try {
      state.maintenanceModeContent = JSON.parse(payload || '');
    } catch (e) {
      state.maintenanceModeContent = {};
    }
  },
  setMaintenanceModeOnlyProduction(state, payload) {
    state.maintenanceModeOnlyProduction = payload;
  },
};
